import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const headerMenuStyles = {
    wrap: css`
        position: relative;
        background: #FFC248;
        padding: 2px 0;
    `,
    menuList: css`
        list-style-type: none;
        display: flex;
        gap: 10px;
        justify-content: center;
        li {
            margin: 5px 0;
        }
    `,
    menuItem: css`
        cursor: pointer;
        &:hover,
        &.active {
            > h6,
            > a {
                background: linear-gradient(to bottom, #FD0108, #970105);
                color: #fff;
                box-shadow: none;
                img {
                    border: 0;
                }
                &::before {
                    opacity: 1;
                    transform: skew(-37deg, 0) translate(0, 0);
                }
            }
        }
    `,
    menuLink: css`
        color: ${colors.black};
        text-transform: uppercase;
        padding: 5px 10px;
        display: block;
        text-decoration: none;
        position: relative;
        z-index: 1;
        overflow: hidden;
        text-align: center;
        min-width: 110px;
        font-weight: 900;
        display: flex;
        align-items: center;
        box-shadow: inset 0em 0em 10px #fff;
        border-radius: 30px;
        font-size: 13px;
        img {
            width: 25px;
            margin-right: 7px;
            border: 2px solid #fff;
            border-radius: 50%;
        }
        &::before {
            content: '';
            position: absolute;
            left: calc(50% - 20px);
            top: 0;
            width: 40px;
            height: 100%;
            /* background: linear-gradient(195deg, #394a6b 10.36%, #121823 86.96%); */
            z-index: -1;
            pointer-events: none;
            opacity: 0;
            transition: 0.25s;
            transform: skew(-37deg, 0) translate(-100%, -100%);
        }
    `,
    baseGameHover: css`
        background: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(24px);
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        z-index: 3;
        height: 0;
        overflow: hidden;

        transition: 0.25s;
    `,
    gameList: css`
        display: flex;
        /* flex-wrap: wrap; */
        justify-content: center;
        gap: 10px;
        padding: 30px 0 15px;
    `,
    gameItem: css`
        padding: 10px 15px;
        padding-top: 0;
        img {
            width: 160px;
            transition: 0.25s;
            margin-bottom: 10px;
            border-radius: 15px;
        }
        &:hover {
            img {
                opacity: 1;
                filter: drop-shadow(0 0 0.75rem #fecd2f);
            }
        }
    `,
    gameName: css`
        text-align: center;
        img {
            transform: scale(0.9);
        }
    `,
    giftCode: css`
        cursor: pointer;
        -webkit-animation: zoomInZoomOut 1s infinite linear;
        animation: zoomInZoomOut 1s infinite linear;
        img {
            width: 100px;
        }
        img.active {
            display: none;
        }
        &:hover {
            img {
                display: none;
            }
            img.active {
                display: block;
            }
        }
    `,
    giftCodeContent: css`
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .giftcode {
            width: 420px;
            position: relative;
        }
        img {
            width: 100%;
            margin: 0 auto;
        }
        .input-code, .submit {
            position: absolute;
            left: 50%;
            bottom: 165px;
            transform: translateX(-50%);
            border: 0;
            border-radius: 7px;
            height: 40px;
            width: 300px;
            color: #312C2C;
            font-weight: 700;
            text-align: center;
            font-size: 20px;
            text-transform: uppercase;
        }
        .input-code {
            left: 62%;
            input {
                width: 90%;
                margin-top: 5px;
                border: 1px solid #B200FF;
                padding: 10px;
                border-radius: 5px;
            }
        }
        .close {
            position: absolute;
            right: 0px;
            top: -15px;
            width: 40px;
            transition: all 0.15s ease-out;
            cursor: pointer;
            &:hover {
                transition: all 0.15s ease-out;
                transform: scale(1.05);
            }
        }
        .submit {
            bottom: 50px;
            background: transparent;
            box-shadow: none;
            cursor: pointer;
            &:hover {
                img {
                    transition: all 0.15s ease-out;
                    transform: scale(1.05);
                }
            }
            img {
                transition: all 0.15s ease-out;
                width: 100%;
            }
        }
    `

};
export default headerMenuStyles;
